import type { RouteConfig } from 'vue-router'
import { ROUTE_NAMES } from './routeNames.const'

export const routeTaxation = ((): RouteConfig => {
  return {
    path: '/taxation',
    name: ROUTE_NAMES.taxationCircuit.taxationPagesContainer,
    component: () =>
      import(
        /* webpackChunkName: "TaxationCircuit" */ 'src/circuits/taxation-circuit/TaxationCircuitContainerView.vue'
      ),
  }
})()
